module.exports = __webpack_public_path__ + "img/MAGAZINE LOADER (Ergonomic Type).b1fe965b.jpg";